import type { StrokeData } from "./bishun-drawing.js";

/**
 * One character's outline file, fetched from where the site publishes them.
 *
 * `src/assets/stroke-data.ts` publishes a file per character under one
 * directory, and the figure, the marked card and the writing drill each fetch
 * the one they draw. A failed fetch answers nothing rather than throwing, since
 * every caller leaves the page as it was drawn in that case.
 *
 * @param url - The directory the files are published under.
 * @param character - The character, which names its file.
 * @param fetching - How to fetch.
 * @returns The file, or nothing where it could not be fetched.
 */
export async function fetchStrokeFile(
  url: string,
  character: string,
  fetching: typeof fetch,
): Promise<StrokeData | undefined> {
  if (url === "" || character === "") {
    return undefined;
  }

  try {
    const response = await fetching(
      `${url}/${encodeURIComponent(character)}.json`,
    );

    return response.ok ? ((await response.json()) as StrokeData) : undefined;
  } catch {
    return undefined;
  }
}
